module.exports = __webpack_public_path__ + "media/images/dryer-ab2cdf6b6073999c6e300ae3f26300d5.gif";